import ApiService from "app/services/ApiService";

export const GET_COMMUNICATIONPROGRAM_REQUEST = 'GET_COMMUNICATIONPROGRAM_REQUEST';
export const GET_COMMUNICATIONPROGRAM_SUCCESS = 'GET_COMMUNICATIONPROGRAM_SUCCESS';
export const GET_COMMUNICATIONPROGRAM_FAILURE = 'GET_COMMUNICATIONPROGRAM_FAILURE';

export const GET_REPORTCOMMUNICATIONPROGRAM_REQUEST = 'GET_REPORTCOMMUNICATIONPROGRAM_REQUEST';
export const GET_REPORTCOMMUNICATIONPROGRAM_SUCCESS = 'GET_REPORTCOMMUNICATIONPROGRAM_SUCCESS';
export const GET_REPORTCOMMUNICATIONPROGRAM_FAILURE = 'GET_REPORTCOMMUNICATIONPROGRAM_FAILURE';

export const SAVE_FILTER_REPORTCOMMUNICATIONPROGRAM = "SAVE_FILTER_REPORTCOMMUNICATIONPROGRAM";
export const CLEAR_GRID_REPORTCOMMUNICATIONPROGRAM = "CLEAR_GRID_REPORTCOMMUNICATIONPROGRAM";

export const EXPORT_COMMUNICATIONPROGRAM_REQUEST = 'EXPORT_COMMUNICATIONPROGRAM_REQUEST';
export const EXPORT_COMMUNICATIONPROGRAM_SUCCESS = 'EXPORT_COMMUNICATIONPROGRAM_SUCCESS';
export const EXPORT_COMMUNICATIONPROGRAM_FAILURE = 'EXPORT_COMMUNICATIONPROGRAM_FAILURE';

export const SAVE_PAGINATION = 'SAVE_PAGINATION';


export const getFilterReportCommunicationProgram = (params) => dispatch => {
    dispatch({ type: GET_COMMUNICATIONPROGRAM_REQUEST });
    ApiService.getFilterReportCommunicationProgram(params).then(
        response => {
            dispatch({
                type: GET_COMMUNICATIONPROGRAM_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_COMMUNICATIONPROGRAM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getReportCommunicationProgramGrid = (params) => dispatch => {
    dispatch({ type: GET_REPORTCOMMUNICATIONPROGRAM_REQUEST });
    ApiService.getReportCommunicationProgramGrid(params).then(
        response => {
            dispatch({
                type: GET_REPORTCOMMUNICATIONPROGRAM_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_REPORTCOMMUNICATIONPROGRAM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const saveFilter = (filter) => ({
    type: SAVE_FILTER_REPORTCOMMUNICATIONPROGRAM,
    payload: filter
});

export const clearGrid = () => ({
    type: CLEAR_GRID_REPORTCOMMUNICATIONPROGRAM,
    payload: []
});

export const exportXls = (param) => dispatch => {
    let objValidate = {}    

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_COMMUNICATIONPROGRAM_REQUEST });
    ApiService.getExportReportCommunicationProgram(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "ReporteCumplimientoProgramaComunicacion.xlsx");

            dispatch({ type: EXPORT_COMMUNICATIONPROGRAM_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_COMMUNICATIONPROGRAM_FAILURE, payload: error.message })
    )
}
export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};